<template>
  <div v-show="innerVisible" class="video-player-bg">
    <div class="video-content">
      <div id="dplayer"></div>
      <em @click="closeVideo">×</em>
    </div>
  </div>
</template>

<script>
import DPlayer from 'dplayer';
import 'dplayer/dist/DPlayer.min.css';
import dialogMixin from './dialogMixin';

export default {
  mixins: [dialogMixin],
  compoments: {
    DPlayer,
  },
  props: {
    videourl: {
      type: String,
      default() {
        return '';
      }
    }
  },
  data() {
    return {
      dplayer: null
    };
  },
  methods: {
    init() {
      this.dplayer = new DPlayer({
        container: document.getElementById('dplayer'),
        autoplay: true,
        video: {
          url: this.videourl
        },
        contextmenu: [
          {
            text: '退出回看',
            click: () => {
              this.innerVisible = false;
              this.dplayer.pause();
            }
          },
        ],
      });
    },
    closeVideo() {
      this.innerVisible = false;
      this.dplayer.pause();
    }
  },
  watch: {
    innerVisible(val) {
      if (val) {
        this.init();
      }
    }
  }
};
</script>
<style scoped>
.video-player-bg{
  position: fixed;
  left:0;
  top:0;
  width: 100%;
  height: 100%;
  z-index: 11;
  background: rgba(0,0,0,.9);
}
.video-content{
  position: absolute;
  top:50%;
  left:50%;
  width: 800px;
  height:450px;
  background: #000;
  margin-left: -400px;
  margin-top: -225px;
}
.video-content em{
  position: absolute;
  top:-70px;
  right:0;
  color: #fff;
  font-size: 55px;
  cursor: pointer;
}
</style>
